<template>
  <DsfFormControlBox
    class="ds-upload-file"
    :class="{'hide-btns': hideBtns, '--simple': simple}"
    :owner="_self"
  >
    <template #simple>
      <DsfTextProxy
        v-model="value"
        v-bind="_self.$props"
      ></DsfTextProxy>
    </template>
    <template #content>
      <template v-if="!readOnly">
        <dsf-button
          v-if="showMultipleFiles && showMultipleFiles.length > 0 && !uploadOneFile && !simpleFileStyle && !hideBtns"
          class="download-button"
          icon="yunduanxiazai"
          @click="downLoadAll"
        >
          全部下载
        </dsf-button>
        <el-upload
          ref="upload"
          class="ds-upload-file-bar"
          :class="{
            'upload-one-file': uploadOneFile,
            'simple-file-style': simpleFileStyle,
            'has-file-list': showMultipleFiles.length,
            'hide-btns': hideBtns
          }"
          :disabled="showMultipleFiles.length >= limit || disabled"
          :accept="acceptMime"
          :multiple="multiple"
          :drag="isDragable"
          :limit="limit"
          :show-file-list="false"
          :http-request="httpRequest"
          :before-upload="beforeUpload"
          :on-exceed="handleExceed"
          action=""
          auto-upload
        >
          <template v-if="isDragable">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">点击上传，或将文件拖拽到此处</div>
          </template>
          <template v-else-if="simpleFileStyle">
            <dsf-button
              v-if="simple && !readOnly"
              btn-style="icon-text"
              :disabled="disabled"
            >
              {{ showBtnName ? btnName : "" }}
            </dsf-button>
          </template>
          <template v-else-if="uploadOneFile">
            <div class="one-file-button">
              {{ showBtnName ? btnName : "" }}
            </div>
          </template>
          <template v-else>
            <dsf-button
              :disabled="showMultipleFiles.length >= limit || disabled"
              icon="yunduanshangchuan"
            >
              {{ showBtnName ? btnName : "" }}
            </dsf-button>
          </template>
        </el-upload>
      </template>
      <template v-if="showMultipleFiles.length">
        <!-- 简易模式在table里显示的内容 -->
        <div
          v-if="simple && !isDesign"
          class="file-list"
        >
          <template v-for="(info, $index) in showMultipleFiles">
            <span
              v-if="!info.status"
              :key="info.id"
              class="file-item"
              :title="getFileTitle(info)"
            >
              <DsfIcon
                name="suo1"
                v-if="isFileEncrypt"
              />
              <i
                class="icon"
                :class="info.suffix"
              ></i>
              <span v-if="!clickPreview">{{ info.name }}.{{ info.suffix }}</span>
              <span
                v-else
                class="view-name"
                @click="rowBtClickPreview(info, $index)"
              >{{ info.name }}.{{ info.suffix }}</span>
              <dsf-icon
                class="file-item-bt"
                name="yunduanxiazai"
                title="下载"
                @click.stop="rowBtClickDownload(info, $index)"
              />
              <dsf-icon
                v-if="!readOnly"
                class="file-item-bt"
                name="weitongguo"
                title="删除"
                @click.stop="rowBtClickDelete(info)"
              />
            </span>
            <span
              v-else
              :key="info.id"
              class="file-item --uploading"
            >
              <i
                class="icon"
                :class="info.suffix"
              ></i>
              <span>{{ info.name }}</span>
              <dsf-icon
                v-if="!readOnly"
                class="file-item-bt"
                name="shanchu1"
                title="删除"
                @click.stop="info.stopHandler"
              />
              <dsf-icon
                v-if="info.status.type == 'error'"
                class="file-item-bt"
                name="icon_refresh"
                title="上传失败，请重新上传"
                style="color: #F56C6C"
                @click.stop="info.suspendHandler"
              />
              <i
                v-else
                class="file-item-progress"
              >{{ info.status._progress }}%</i>
            </span>
          </template>
        </div>
        <div
          v-else
          class="file-list"
        >
          <div class="file-list-row header">
            <div class="file-list-row-box">
              <div
                v-if="!uploadOneFile"
                class="file-list-col"
                style="width: 60px"
              >序号</div>
              <div
                class="file-list-col"
                style="flex: auto; width: 0;"
              >文件名</div>
              <div
                v-if="showFileDate"
                class="file-list-multipleFilescol"
                style="width: 160px"
              >上传时间</div>
              <div
                v-if="showFileSize"
                class="file-list-col"
                style="width: 90px"
              >文件大小</div>
              <template v-if="isFileEncrypt">
                <div
                  class="file-list-col"
                  style="width: 120px"
                >密级</div>
                <div
                  class="file-list-col"
                  style="width: 170px"
                  v-if="editEncryptfileDeadline"
                >解密日期</div>
              </template>
              <div
                class="file-list-col _bt _bt1"
                :style="{width: readOnly ? '90px' : '200px'}"
              ></div>
            </div>
          </div>
          <template v-for="(info, $index) in showMultipleFiles">
            <div
              v-if="!info.status"
              :key="info.id"
              class="file-list-row"
            >
              <div class="file-list-row-box">
                <div
                  v-if="!uploadOneFile"
                  class="file-list-col"
                  style="width: 60px"
                >{{ $index + 1 }}</div>
                <div
                  class="file-list-col"
                  style="flex: auto; width: 0;"
                >
                  <div class="ds-multi-ellipsis-1">
                    <DsfIcon
                      name="suo1"
                      v-if="isFileEncrypt"
                    />
                    <i
                      class="icon"
                      :class="info.suffix"
                    ></i>
                    <span v-if="!clickPreview">{{ info.originalFileName }}</span>
                    <span
                      v-else
                      class="view-name"
                      @click="rowBtClickPreview(info, $index)"
                    >{{ info.originalFileName }}</span>
                  </div>
                </div>
                <div
                  v-if="showFileDate"
                  class="file-list-col"
                  style="width: 160px"
                >
                  {{ info.uploadDate | proxy(dateFormatter) }}
                </div>
                <div
                  v-if="showFileSize"
                  class="file-list-col"
                  style="width: 90px"
                >
                  {{ computeFileSize(info.size) }}
                </div>
                <template v-if="isFileEncrypt">
                  <div
                    class="file-list-col"
                    style="width: 120px"
                  >
                    <div
                      class="file-list-col-flex"
                      v-if="info.isNew"
                    >
                      <el-select
                        v-model="info.securityLevelValue"
                        placeholder="请选择"
                        @focus="handleEncryptFocus"
                        @change="securityLevelChange($event, info)"
                        size="small"
                      >
                        <el-option
                          v-for="item in securityLevel"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <span v-else>{{ info.securityLevelText }}</span>
                  </div>
                  <div
                    class="file-list-col"
                    style="width: 170px"
                    v-if="editEncryptfileDeadline"
                  >
                    <span v-if="info.securityLevelExpiryDate">{{ dsf.date.format(info.securityLevelExpiryDate, "yyyy-mm-dd") }}</span>
                  </div>
                </template>
                <div
                  class="file-list-col _bt _bt1"
                  :style="{width: readOnly ? '90px' : '200px'}"
                >
                  <template v-for="(item) of handleList">
                    <dsf-icon
                      v-if="!item.hide || !item.hide(info, $index)"
                      :key="item.id"
                      :name="item.icon"
                      :title="item.name"
                      @click="item.hanlder(info, $index)"
                    />
                  </template>
                </div>
              </div>
            </div>
            <div
              v-else
              :key="info.id"
              class="file-list-row"
            >
              <div
                class="file-list-row-progress"
                :style="{transform: `scaleX(${info.status.progress / 100})`}"
              ></div>
              <div class="file-list-row-box">
                <div
                  class="file-list-col"
                  style="width: 60px"
                >
                  <i
                    v-if="info.status.type == 'error'"
                    class="el-icon-warning-outline"
                  ></i>
                  <i
                    v-else
                    class="el-icon-loading"
                    :class="{suspend: info.status.type == 'suspend'}"
                  ></i>
                </div>
                <div
                  class="file-list-col"
                  style="flex: auto; width: 0;"
                >
                  <div class="ds-multi-ellipsis-1">
                    <i
                      class="icon"
                      :class="info.suffix"
                    ></i>{{ info.originalFileName }}
                  </div>
                </div>
                <div
                  class="file-list-col"
                  style="width: 200px"
                >
                  {{ computeFileSize(info.size) }}
                  <span
                    v-if="info.status.speed"
                    style="opacity: .8"
                  >({{ info.status.speed }})</span>
                </div>
                <div
                  class="file-list-col"
                  style="width: 90px;text-align: center;"
                >
                  <span v-if="info.status.type == 'suspend'">已暂停</span>
                  <el-tooltip
                    v-else-if="info.status.type == 'error'"
                    :content="info.status.errorMsg"
                    effect="light"
                    placement="top"
                  >
                    <span style="color: #F56C6C">失败</span>
                  </el-tooltip>
                  <span v-else>{{ info.status._progress }}%</span>
                </div>
                <div
                  class="file-list-col _bt _bt2"
                  style="width: 120px;"
                >
                  <dsf-icon
                    v-show="info.status.type == 'error'"
                    name="icon_refresh"
                    title="重新上传"
                    @click="info.suspendHandler"
                  />
                  <!--<dsf-icon v-show="info.status.type == 'uploading'" name="zanting" title="暂停" @click="info.suspendHandler" />
                  <dsf-icon v-show="info.status.type == 'suspend'" name="yunhang" title="继续" @click="info.suspendHandler" />-->
                  <dsf-icon
                    name="weitongguo"
                    @click="info.stopHandler"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
      <div
        v-if="errors.length > 0 && showMultipleFiles.length <= 0"
        class="ds-error-text"
      >
        {{ errorsMsg }}
      </div>
    </template>
  </DsfFormControlBox>
</template>

<script>
const canOnlineEditOfSuffix = ["xls", "xlsx", "doc", "docx"];
const imgList = ["png", "jpg", "jpeg", "bmp", "gif"];
const globalImgs = [];

export default dsf.component({
  name: "DsfUploadFile",
  mixins: [$mixins.formControl, $mixins.fileEncrypt],
  ctrlCaption: "文件上传",
  props: {
    // 只读状态简版(表格中有效)
    simple: {
      type: Boolean,
      default: false,
    },
    // 是否使用简易上传样式
    simpleFileStyle: {
      type: Boolean,
      default: false,
    },
    // 文件日期格式
    dateFormatter: {
      type: String,
      default: "dateTime^yyyy-mm-dd hh:ii",
    },
    // 只读状态下格式化
    formatter: {
      type: String,
      default: "multipleFiles^originalFileName",
    },
    // 名称
    label: {
      type: String,
      default: "文件上传",
    },
    // 按钮名称
    btnName: {
      type: String,
      default: "文件上传",
    },
    // 按钮名称是否显示
    showBtnName: {
      type: Boolean,
      default: true,
    },
    // 是否支持多张上传
    multiple: {
      type: Boolean,
      default: true,
    },
    // 上传文件数量
    uploadFileNum: {
      type: [Number, String],
      default: 5,
    },
    // 只配置单个文件上传
    uploadOneFile: {
      type: Boolean,
      default: false,
    },
    // 单个文件大小(MB)
    maxFileSize: {
      type: [Number, String],
      default: 0,
    },
    // 文件打包下载文件名称
    zipFileName: {
      type: String,
      default: "",
    },
    // 必填标识
    required: {
      type: Boolean,
      default: false,
    },
    // 是否在当前页面预览图片
    isViewImages: {
      type: Boolean,
      default: true,
    },
    // 是否开启拖拽
    isDragable: {
      type: Boolean,
      default: false,
    },
    // 文件上传接口
    requestUrl: {
      type: String,
      default: "",
    },
    // 文件上传条件设置
    extsSetting: {
      type: Object,
      default() {
        return {};
      },
    },
    metadata: {
      type: Object,
      default() {
        let mdata = dsf.metadata.get("file-meta-data");
        mdata = dsf.mix(mdata, {
          isFileEncrypt: false,
          dataSource: {
            attachTipsMaps: {},
            code: dsf.config.setting_encrypt_level_dictionary,
            type: "dict",
          },
        });
        return mdata;
      },
    },
    hideBtns: {
      type: Boolean,
      default() {
        return false;
      },
    },
    // 外部传入的文件列表
    files: {
      type: Array,
      default() {
        return [];
      },
    },
    // 文件名可以点击预览
    clickPreview: {
      type: Boolean,
      default: false,
    },
    // 是否开启在线编辑
    canOnlineEdit: {
      type: Boolean,
      default: false,
    },
    // 在线编辑是否开启留痕
    showRevisionMode: {
      type: Boolean,
      default: false,
    },
    // 是否显示文件日期
    showFileDate: {
      type: Boolean,
      default: true,
    },
    // 是否显示文件日期
    showFileSize: {
      type: Boolean,
      default: true,
    },
    // 是否开启视频切片功能
    canCutVideo: {
      type: Boolean,
      default: false,
    },
    // 是否静态，为true时isPublic失效
    isStatic: {
      type: Boolean,
      default: false,
    },
    // 是否公开
    isPublic: {
      type: Boolean,
      default: true,
    },
    // 下载文件为上传文件名
    initialFileName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    this.orders = [];
    return {
      updateKey: 0,
      limit: 0,
      isShowDownloadBtn: false, // 是否显示下载按钮
      // multipleFiles: [], // 上传文件数组
      uploadFileType: "file", //默认上传类型
      uploadFileExts: [], //允许上传后缀名
      acceptMime: "", // 弹窗筛选条件MiMe类型
      uploadingFileMap: {}, // 正在上传的文件
      cutSuccessMap: {}, // 已切片的视频
      autoUpload: true,
      uploadedFiles: 0, // 已经上传的文件数量
      uploadingFileIds: [], // 正在上传的文件id
    };
  },
  computed: {
    handleList() {
      if (this.readOnly) {
        return [
          { id: "preview", icon: "icon-visible", name: "预览", hanlder: this.rowBtClickPreview },
          { id: "download", icon: "yunduanxiazai", name: "下载", hanlder: this.rowBtClickDownload },
        ];
      }
      let res = [
        { id: "up", icon: "shang", name: "上移", hide: (info, index) => !index, hanlder: this.rowBtClickUp },
        { id: "down", icon: "xia", name: "下移", hide: (info, index) => index + 1 == this.showMultipleFiles.length, hanlder: this.rowBtClickDown },
        { id: "preview", icon: "icon-visible", name: "预览", hanlder: this.rowBtClickPreview },
        { id: "download", icon: "yunduanxiazai", name: "下载", hanlder: this.rowBtClickDownload },
        { id: "upload", icon: "yunduanshangchuan", name: "重新上传", hanlder: this.rowBtClickUpload },
        // {icon: '', name: '修改名称'}
      ];
      if (this.canCutVideo) {
        res.push({
          id: "videoSlicing",
          icon: "qiepian",
          name: "视频切片",
          hide: (info) => {
            return info.suffix.toLowerCase() !== "mp4" || this.cutSuccessMap[info.id];
          },
          hanlder: this.rowBtClickVideoSlicing,
        });
      }
      res.push({ id: "edit", icon: "bianji", name: "在线编辑", hide: (info) => !this.showOnlineEdit(info), hanlder: this.rowBtClickEdit }, { id: "delete", icon: "delete", name: "删除", hanlder: this.rowBtClickDelete });
      return res;
    },
    filesMap() {
      let res = {};
      _.each(this.files, (it) => {
        if (!_.find(this.orders, (id) => id == it.id)) {
          this.orders.push(it.id);
        }
        res[it.id] = it;
      });
      return res;
    },
    valueMap() {
      if (!this.value && !dsf.isString(this.value)) return [];
      try {
        let val = JSON.parse(this.value);
        if (dsf.isArray(val)) {
          let res = {};
          _.each(val, (it) => {
            if (!_.find(this.orders, (id) => id == it.id)) {
              this.orders.push(it.id);
            }
            res[it.id] = it;
          });
          return res;
        }
        return {};
      } catch (e) {
        return {};
      }
    },
    multipleFiles() {
      let { updateKey, orders, uploadingFileMap, filesMap, valueMap } = this;
      updateKey = parseInt(updateKey);
      let res = [];
      _.eachRight(orders, (id, i) => {
        let it = filesMap[id] || valueMap[id] || uploadingFileMap[id];
        if (it) {
          // 新上传文件后value置空,防止下拉框出现不匹配的选项
          if (this.isFileEncrypt) {
            if (it.isNew && it.securityLevelValue == -10) {
              if (this.securityLevel.length) {
                const { text, value } = this.securityLevel[0];
                it.securityLevelValue = value;
                it.securityLevelText = text;
              } else {
                it.securityLevelValue = "";
              }
            }
          }
          res.unshift(it);
        } else {
          orders.splice(i, 1);
        }
      });
      return res;
    },
    // 若是密级文件则隐藏高于当前用户密级的文件
    showMultipleFiles() {
      if (!this.isFileEncrypt) return this.multipleFiles;
      let files = _.filter(this.multipleFiles, (it) => this.validate(it.securityLevelValue));
      return files;
    },
    extendData() {
      let { isStatic, isPublic } = this;
      let res = {
        isStatic: Number(isStatic),
        isPublic: Number(isPublic),
      };
      if (isStatic && this.$vm) {
        res["namespace"] = this.$vm.nameSpace;
        res["pageName"] = this.$vm.pageName;
      }

      if (this.isFileEncrypt) {
        res["securityLevelValue"] = "";
        res["securityLevelText"] = "";
        res["securityLevelExpiryDate"] = "";
      }

      return res;
    },
    // 人员密级  20:非涉密  30:一般  40:重要  50:核心
    user_security_level() {
      let securityLevel = this.$vm.$viewInitData?.[this.metadata.dataKey]?.dataSource || [];
      if (dsf.isArray(securityLevel) && securityLevel.length > 0) {
        let levels = _.map(securityLevel, (item) => item.value);
        return Math.max.apply(null, levels) + "";
      }
      return "20";
    },
  },
  watch: {
    uploadOneFile: {
      handler(to) {
        if (to) {
          this.$emit("update:multiple", false);
          this.$emit("update:btnName", "请点击上传文件");
          this.limit = 100;
        } else {
          this.$emit("update:multiple", true);
          this.limit = parseInt(this.uploadFileNum);
        }
      },
      immediate: true,
    },
    extsSetting: {
      handler(to) {
        this.initExtsSetting(to);
      },
      immediate: true,
    },
    isFileEncrypt: {
      handler(value) {
        let mdata = this.metadata;
        let label = value ? "密级文件" : "文件上传";
        mdata = dsf.mix(mdata, { isFileEncrypt: value });
        this.$emit("update:metadata", mdata);
        this.$emit("update:label", label);
      },
      immediate: true,
    },
    showMultipleFiles() {
      this.uploadedFiles = this.showMultipleFiles.length;
    },
  },
  created() {
    globalImgs.push(this);
    this.initExtsSetting(this.extsSetting);
  },
  beforeDestroy() {
    _.filter(this.uploadingFileMap, (file) => !!file.stopHandler).forEach((file) => file.stopHandler());
    dsf.array.remove(globalImgs, this);
  },
  methods: {
    handleEncryptFocus() {
      if (this.formEncryptLevel === "") {
        dsf.layer.message("请选择页面【密级】字段", false);
      }
    },
    // 密级切换
    async securityLevelChange(e, item) {
      // 切换前先获取过期时间
      const securityLevelExpiryDate = await this.getExpiryDate(item.securityLevelValue);
      let securityLevelText = _.find(this.securityLevel, (it) => it.value === e)?.text;

      this.updateFileSecret(
        {
          ...item,
          securityLevelExpiryDate,
          securityLevelText,
          securityLevelValue: e,
        },
        () => {
          // 提交成功后，更新列表
          item.securityLevelText = securityLevelText || "";
          item.securityLevelExpiryDate = securityLevelExpiryDate;
          this.updateValue(this.multipleFiles);
        }
      );
    },
    // 切换密级是向后端提交一次
    updateFileSecret(item, cb) {
      let params = {
        dmId: item.id,
        securityLevelValue: item.securityLevelValue,
        securityLevelText: item.securityLevelText,
        securityLevelExpiryDate: item.securityLevelExpiryDate,
      };
      this.$http.post("/file/updateFileSecret", params).then(({ data }) => {
        let { success, message } = data;
        if (!success) {
          dsf.layer.message(message || "请求异常", false);
        } else {
          cb();
        }
      });
    },
    computeFileSize: dsf.fileSizeToString,
    // 解析上传文件格式的限制条件
    initExtsSetting(obj) {
      if (obj.extStr) {
        this.uploadFileType = obj.fileType;
        this.acceptMime = obj.mineStr;
        let uploadFileExts = [];
        _.each(obj.extStr?.split(",") || [], (it) => {
          it = _.trim(it);
          if (!it.startsWith(".")) {
            uploadFileExts.push("." + it);
          }
          uploadFileExts.push(it);
        });
        this.uploadFileExts = uploadFileExts;
        // this.isLinkeMine = obj.isLinkeMine;
      }
    },
    // 上传文件之前的钩子
    // 若返回 false 或者返回 Promise 且被 reject，则停止上传。
    async beforeUpload(file, replaceId) {
      this.uploadedFiles += 1;
      if (this.$listeners["before-upload-customer"]) {
        // 在上传前触发自定义事件，并等待父组件的处理结果
        const result = await new Promise((resolve, reject) => {
          this.$emit("before-upload-customer", file, resolve);
        });

        // 根据父组件的处理结果继续上传或阻止上传
        if (result !== "continue") {
          // 不继续上传
          return false;
        }
      }
      if (!replaceId && this.limit < this.uploadedFiles) {
        dsf.layer.message(`当前限制选择最多 ${this.limit} 个文件`, false);
        this.uploadedFiles -= 1;
        return Promise.reject(false);
      }
      // 判断文件格式
      if (this.uploadFileExts.length) {
        let suffix = "." + this.getFileSuffix(file.name);
        if (!~this.uploadFileExts.indexOf(suffix)) {
          dsf.layer.message(`选择文件中包含不支持的文件格式,请选择包含这些格式的文件：${this.uploadFileExts.join(",")}`, false);
          this.uploadedFiles -= 1;
          return false;
        }
      }
      // 判断文件大小
      let maxSize = this.maxFileSize ? this.getFileSize(this.maxFileSize) : "";
      let isMaxSize = maxSize ? file.size / 1024 < maxSize : true;
      if (!isMaxSize) {
        dsf.layer.message(`文件大小不能超过${parseInt(this.maxFileSize)}MB`, false);
        this.uploadedFiles -= 1;
        return false;
      }
      // 是否重复文件上传
      let isSome = _.some(this.multipleFiles, (it) => {
        return it.originalFileName == file.name && it.contentType === file.type && it.size === file.size;
      });
      if (isSome && !replaceId) {
        dsf.layer.message(`已存在文件【${file.name}】，请修改后重新上传`, false);
        this.uploadedFiles -= 1;
        return Promise.reject(false);
      }

      // 如果当前上传文件数量等于已上传数量
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      // 同时最多只能上传数量只能为
      dsf.layer.message(`当前限制选择最多 ${this.limit} 个文件`, false);
    },
    // 自定义上传
    httpRequest({ file }, replaceId) {
      this.$refs.upload.clearFiles();
      let uploader = dsf.createUploader(file, {
        uploadFileUrl: this.requestUrl || "file/upload/",
        extendData: this.extendData,
      });
      let suffix = this.getFileSuffix(file.name);
      let info = {
        id: dsf.uuid(),
        suffix,
        name: file.name.replace("." + suffix, ""),
        size: file.size,
        contentType: file.type,
        originalFileName: file.name,
        status: {
          progress: 0,
          _progress: 0,
          loaded: "0B",
          speed: "校验中...",
          type: "reading",
        },
        stopHandler: () => {
          uploader.stop();
          uploader = void 0;
          this.$delete(this.uploadingFileMap, info.id);
        },
        suspendHandler: () => {
          if (uploader.status == dsf.SplitUploader.STATUS.uploading) {
            uploader.suspend();
          } else {
            uploader.run();
          }
        },
      };
      if (!replaceId) {
        this.orders.push(info.id);
      } else {
        let index = _.findIndex(this.orders, (id) => id == replaceId);
        this.orders[index] = info.id;
      }
      this.$set(this.uploadingFileMap, info.id, info);
      uploader.on(dsf.SplitUploader.EVENT_TYPE.speed, ({ progress, _speed }) => {
        this.$set(info.status, "speed", progress == 100 ? "合并文件..." : _speed);
      });
      uploader.on(dsf.SplitUploader.EVENT_TYPE.uploading, ({ _loaded, _speed, progress }) => {
        this.$set(info, "status", {
          progress,
          _progress: parseInt(progress),
          speed: progress == 100 ? "合并文件..." : _speed,
          loaded: _loaded,
          type: "uploading",
        });
      });
      uploader.on(dsf.SplitUploader.EVENT_TYPE.finish, async (res) => {
        this.$refs.upload.uploadFiles = [];
        res = res[0];
        // 添加切片按钮
        if (this.canCutVideo && suffix == "mp4") {
          let isCutSuccess = await this.videoIsCut(res); // 后台是否切片成功
          this.$set(this.cutSuccessMap, res.id, !!isCutSuccess);
        }
        let index = _.findIndex(this.orders, (id) => id == info.id);
        this.orders[index] = res.id;
        this.$delete(this.uploadingFileMap, info.id);

        // isNew字段用于区别是刚选择的文件还是已保存过的文件
        let value = this.updateValue({
          ...res,
          isNew: true,
        });
        uploader = void 0;
        // 上传完成对外抛出当前数据
        this.$nextTick(() => {
          this.$dispatch("upload-file-complete", value);
        });
      });
      uploader.on(dsf.SplitUploader.EVENT_TYPE.suspend, ({ _loaded, _speed, progress }) => {
        this.$set(info, "status", {
          progress,
          _progress: parseInt(progress),
          speed: _speed,
          loaded: _loaded,
          type: "suspend",
        });
      });
      uploader.on(dsf.SplitUploader.EVENT_TYPE.error, (e) => {
        this.$refs.upload.uploadFiles = [];
        this.$set(info, "status", {
          progress: 0,
          _progress: 0,
          speed: "",
          loaded: file.size,
          type: "error",
          errorMsg: e.stack === void 0 ? e.message : "请求异常",
        });
      });
      uploader.on(dsf.SplitUploader.EVENT_TYPE.stop, () => {
        this.$refs.upload.uploadFiles = [];
        uploader = undefined;
      });
    },
    //获取文件大小
    getFileSize(data) {
      let fileSize = parseInt(data);
      if (fileSize || data.indexOf("M") > -1 || data.indexOf("m") > -1) {
        fileSize *= 1024;
      }
      return fileSize;
    },
    //获取文件后缀
    getFileSuffix(fileName) {
      let suffix = "";
      let dotIndex = fileName.lastIndexOf(".");
      if (dotIndex > 0) {
        suffix = fileName.substring(dotIndex + 1).toLowerCase();
      }
      return suffix;
    },
    showOnlineEdit(file) {
      if (!this.canOnlineEdit) {
        return false;
      }
      if (this.readonly) {
        return false;
      }
      return canOnlineEditOfSuffix.indexOf(file.suffix) >= 0;
    },
    rowBtClickUp(row, index) {
      if (index !== 0) {
        let it1 = this.orders[index - 1];
        let it2 = this.orders[index];
        this.orders[index - 1] = it2;
        this.orders[index] = it1;
        this.updateValue();
      }
    },
    rowBtClickDown(row, index) {
      if (index + 1 < this.orders.length) {
        let it1 = this.orders[index];
        let it2 = this.orders[index + 1];
        this.orders[index] = it2;
        this.orders[index + 1] = it1;
        this.updateValue();
      }
    },
    rowBtClickPreview(row, index) {
      const preUrl = dsf.config.setting_public_file_host;
      const relativePath = this.$getWebPath(row.relativePath, true);
      let url = `/preview/file?url=${preUrl}${relativePath}`;
      if (this.$listeners["file-view"]) {
        this.$dispatch("file-view", row);
      } else {
        // 进行图片匹配
        let result = imgList.find((item) => item === row.suffix.toLocaleLowerCase());
        if (result && globalImgs.length && this.isViewImages) {
          this.imagesView(relativePath);
        } else {
          this.$openWindow({ url: url, name: row.id });
        }
      }
    },
    rowBtClickDownload(row, index) {
      if (this.isFileEncrypt) {
        // let result = this.validate(row?.securityLevelValue);
        // if (!result) {
        //   dsf.layer.pc.message("您没有下载权限，请联系管理员！", false);
        //   return false;
        // }
      }
      if (this.$listeners["file-download"]) {
        this.$dispatch("file-download", row);
      } else {
        dsf.file.download(
          "/file/download",
          {
            files: row.id,
            zipName: row.name,
          },
          row.originalFileName
        );
      }
    },
    rowBtClickUpload(row, index) {
      dsf.file.load(this.acceptMime).then((file) => {
        if (this.beforeUpload(file, row.id) !== false) {
          this.httpRequest({ file }, row.id);
        }
      });
    },
    rowBtClickDelete(row, noConfirm = false) {
      if (noConfirm) {
        dsf.array.remove(this.orders, row.id);
        this.updateValue();
        this.$nextTick(() => {
          this.$dispatch("file-remove", row);
        });
      } else {
        dsf.layer
          .confirm(`确定要删除【${row.originalFileName}】文件吗?`)
          .then(() => {
            dsf.array.remove(this.orders, row.id);
            this.updateValue();
            this.$nextTick(() => {
              this.$dispatch("file-remove", row);
            });
          })
          .catch((e) => e);
      }
    },
    rowBtClickVideoSlicing(row, index) {
      let url = `/slice/manual/video/${row.id}`;
      if (this.$listeners["cut-file"]) {
        this.$dispatch("cut-file", row);
      } else {
        let loading = dsf.layer.loading();
        this.$http
          .get(url)
          .done(({ success, message }) => {
            if (success) {
              this.$set(this.cutSuccessMap, row.id, true);
              dsf.layer.message("视频切片发起成功！");
            } else {
              dsf.layer.message(message || "视频切片失败，请稍后再试", false);
            }
          })
          .error((err) => {
            dsf.layer.message(err?.message || "请求异常", false);
          })
          .always(() => {
            dsf.layer.closeLoading(loading);
          });
      }
    },
    rowBtClickEdit(row, index) {
      this.wpsOnlineEdit(row);
    },
    wpsOnlineEdit(file) {
      if (window.openOffice) {
        this.onlineEdit(file);
      } else {
        const plugins = [
          this.$getWebPath("$/js/libs/wpsOnlineEdit/static/js/json2.js"),
          this.$getWebPath("$/js/libs/wpsOnlineEdit/static/js/wps_sdk.js"),
          this.$getWebPath("$/js/libs/wpsOnlineEdit/static/js/wpsjsrpcsdk.js"),
          this.$getWebPath("$/js/libs/wpsOnlineEdit/static/js/wps-new.js"),
          this.$getWebPath("$/js/libs/wpsOnlineEdit/static/js/office-edit-wps.js"),
        ];
        this.$http
          .importFiles(plugins)
          .then(() => {
            this.onlineEdit(file);
          })
          .catch((err) => {
            dsf.$message("加载在线编辑插件出错", false);
          });
      }
    },
    onlineEdit(file) {
      if (window.openOffice) {
        // https://open.wps.cn/docs/client/wpsLoad
        let type = ["xls", "xlsx"].includes(file.suffix) ? "excel" : "word",
          fileId = file.id,
          fileName = file.name,
          username = dsf.cookies.get("a"),
          userId = dsf.cookies.get("userId") || dsf.uuid(),
          showRevisionMode = this.showRevisionMode;
        let data = {
          userName: username, //用户名
          userId: userId,
          saveAsFileName: fileName, //附件另存为名称
          newFileName: fileName,
          realFileName: fileName,
          fileName: this.getWebPath("file/download?files=" + fileId), //文件下载地址
          closeUrl: this.getWebPath("office/closeOffice"), //文件关闭回调地址
          uploadPath: this.getWebPath("office/saveOffice?fileId=" + fileId), //文件上传地址
          printWatermark: false,
          buttonGroups: "",
          docId: fileId,
          disableBtns: "ExportToPDF,FileSaveAsPicture,SaveAsPicture,ReviewTrackChangesMenu,FileMenuSendMail,ExportToOFD,FileNew,FileOpen",
          funcs: [
            {
              OnOpenRevisionClickedFromWeb: {
                bShowRevision: showRevisionMode, //是否显示痕迹
                bOpenRevision: showRevisionMode, //是否打开留痕
              },
            },
            {
              OnClearRevDocClicked: {
                bShowRevision: showRevisionMode, //是否显示痕迹
                bOpenRevision: showRevisionMode, //是否打开留痕
              },
            },
            {
              setOpenType: {
                password: "123**",
                readonly: 2, //1:只读不能编辑 2：只读能编辑
                protectType: 3,
                showRevisionMode: showRevisionMode,
              },
            },
          ],
          isOA: 1,
        };
        openOffice(data, type);
      }
    },
    getWebPath(url) {
      let location = window.location,
        origin = location.origin;
      if (!origin) {
        origin = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
      }
      return origin + "/" + url;
    },
    // 判断上传的视频是否切片
    videoIsCut(data) {
      let url = `/slice/video/${data.id}`;
      if (this.$listeners["video-cut"]) {
        this.$dispatch("video-cut", data);
        return Promise.resolve();
      } else {
        let loading = dsf.layer.loading();
        return this.$http
          .get(url)
          .done(({ success, data, message }) => {
            if (success) {
              // 获取标清切片文件
              let suffix = this.getFileSuffix(data.sd.name);
              //不等于m3u8,则表示后台自动切片失败
              return suffix == "m3u8";
            } else {
              dsf.layer.message("处理mp4文件" + message, false);
            }
          })
          .error((res) => {
            dsf.layer.message(res.message, false);
          })
          .always(() => {
            dsf.layer.closeLoading(loading);
          });
      }
    },
    imagesView(relativePath) {
      let result = null;
      let selectImages = [],
        n = 0,
        index = 0;
      _.forEach(globalImgs, (vm) => {
        if (vm.isViewImages && vm.multipleFiles.length) {
          _.forEach(vm.multipleFiles, (v) => {
            result = imgList.find((item) => item === v.suffix.toLocaleLowerCase());
            if (result) {
              selectImages.push(this.$getWebPath(v.relativePath, true));
              if (vm === this && this.$getWebPath(v.relativePath, true) == relativePath) {
                index = n;
              }
              n++;
            }
          });
        }
      });
      dsf.layer.imagePreview({
        images: selectImages,
        startPosition: index,
      });
    },
    clearAll() {
      this.$refs.upload?.clearFiles();
      this.orders = [];
      this.uploadingFileMap = {};
      this.emitValueChange(JSON.stringify([]));
    },
    // 下载全部
    downLoadAll() {
      if (this.$listeners["file-all-download"]) {
        this.$dispatch("file-all-download", this);
      } else {
        let fileIds = [];
        let paramID = "";
        for (let i = 0; i < this.showMultipleFiles.length; i++) {
          let id = this.showMultipleFiles[i].id;
          let name = this.showMultipleFiles[i].name;
          let file = id + "^" + name;
          fileIds.push(file);
        }
        paramID = fileIds.join(",");
        dsf.file.download(
          "/file/download",
          {
            files: paramID,
            zipName: this.zipFileName,
            initialFileName: this.initialFileName,
          },
          this.zipFileName
        );
      }
    },
    getFileTitle(info) {
      return [`${info.name}.${info.suffix}`, `上传时间：${info.uploadDate}`, `大小：${this.computeFileSize(info.size)}`].join("\n");
    },
    openSelectFile() {
      this.$refs.upload.$refs["upload-inner"].handleClick();
    },
    updateValue(info) {
      let arr = [],
        map = _.clone(this.valueMap);
      if (info) {
        map[info.id] = info;
      }
      _.each(this.orders, (id) => {
        let it = map[id];
        if (it) {
          arr.push(it);
        }
      });
      let val = JSON.stringify(arr);
      if (this.value == val) {
        this.updateKey++;
      } else {
        this.emitValueChange(val);
      }
      return arr;
    },
    postBefore() {
      // 提交前删掉 isNew 字段
      let uploadingIds = [];
      _.forEach(this.multipleFiles, (it) => {
        if (it.securityLevelValue === "") it.securityLevelValue = -10;
        if (it.isNew) {
          uploadingIds.push(it.id);
        }
        delete it.isNew;
      });
      this.uploadingFileIds = uploadingIds;
      this.updateValue(this.multipleFiles);
      let uploading = _.find(this.uploadingFileMap, (file) => {
        return file.status.type == dsf.SplitUploader.STATUS.readying || file.status.type == dsf.SplitUploader.STATUS.ready || file.status.type == dsf.SplitUploader.STATUS.uploading || file.status.type == dsf.SplitUploader.STATUS.suspend;
      });
      if (!uploading) {
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        dsf.layer
          .confirm({
            confirmButtonText: "继续",
            cancelButtonText: "取消",
            title: "提示",
            message: "当前有文件正在上传中，继续提交表单，将终止上传，是否继续？",
          })
          .then(() => {
            _.filter(this.uploadingFileMap, (file) => !!file.stopHandler).forEach((file) => file.stopHandler());
            resolve();
          })
          .catch(() => {
            reject({
              type: "nextFalse",
              message: "当前还有文件正在上传中，终止表单提交。",
            });
          });
      });
    },
    postError() {
      // 如果当前表单保存失败，则把新增的文件重新打上标签
      _.forEach(this.multipleFiles, (it) => {
        if (this.uploadingFileIds.includes(it.id)) {
          it.isNew = true;
        }
      });
      this.uploadingFileIds = [];
    },
    // 权限校验
    validate(value) {
      if (!value) return true;
      return Number(value) <= Number(this.user_security_level);
    },
  },
});
</script>
